import type { FC, ReactNode } from 'react'

/**
 * Props for Block.Title.Actions
 */
export type BlockHeaderActionsProps = {
  children?: ReactNode
}

/**
 * Block.Title.Actions - Container for action buttons in a block title
 *
 * Wraps action buttons (Block.Title.Action) in an HLayout with gap-2.
 * Placed on the right side of the block title, isolated from the accordion trigger.
 *
 * @example
 * ```tsx
 * <Block.Title>
 *   My title
 *   <Block.Title.Actions>
 *     <Block.Title.Action label="Edit" onClick={() => {}} />
 *     <Block.Title.Action icon={{ component: TrashIcon }} onClick={() => {}} />
 *   </Block.Title.Actions>
 * </Block.Title>
 * ```
 */
export const BlockHeaderActions: FC<BlockHeaderActionsProps> = ({ children }) => {
  return <div className="flex shrink-0 flex-row gap-2">{children}</div>
}

BlockHeaderActions.displayName = 'BlockHeaderActions'
